module.exports = __webpack_public_path__ + "img/goFluent_logo_1.61494713.svg";